import type React from "react";

export const LineaIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="200"
    height="208"
    viewBox="0 0 200 208"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="199.4" height="207.623" fill="#61DFFF" />
    <g clipPath="url(#clip0_2318_291)">
      <path
        d="M132.369 155.99H49.7001V68.8854H68.6148V139.109H132.369V155.981V155.99Z"
        fill="#121212"
      />
      <path
        d="M132.369 85.7575C141.687 85.7575 149.241 78.2037 149.241 68.8855C149.241 59.5673 141.687 52.0134 132.369 52.0134C123.05 52.0134 115.497 59.5673 115.497 68.8855C115.497 78.2037 123.05 85.7575 132.369 85.7575Z"
        fill="#121212"
      />
    </g>
    <defs>
      <clipPath id="clip0_2318_291">
        <rect
          width="99.5407"
          height="103.977"
          fill="white"
          transform="translate(49.7001 52.0134)"
        />
      </clipPath>
    </defs>
  </svg>
);
